import n403 from '@/assets/imgs/403.svg';
import Error from './components/Error';

function Server403() {
  return <Error title="403" type="403" imgSrc={n403}></Error>;
}

export default Server403;
